import React from 'react';

// mui
import { Container, Box } from '@mui/system';
import { Typography, Grid, IconButton, Tooltip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';

// block groups
import BaseTable from '../../../../../blockGroups/table/BaseTable/BaseTable.blockgroup';

// utils
import { cleanJobDayAssignments } from './JobDayDetailAssignments.collection.utils';

const crewDetailColumnConfigs = [
    { 
        name: "name", 
        title: "Name", 
        objectFieldsToDisplay: ["name"],
        objectFieldsDelimeter: "",
        useNestedObject: false 
    },
    { 
        name: "position", 
        title: "Position", 
        objectFieldsToDisplay: ["position"],
        objectFieldsDelimeter: "", 
        useNestedObject: false 
    },
    { 
        name: "time", 
        title: "Time", 
        objectFieldsToDisplay: ["time"],
        objectFieldsDelimeter: "", 
        useNestedObject: false 
    },
    { 
        name: "hours", 
        title: "Hours", 
        objectFieldsToDisplay: ["hours"],
        objectFieldsDelimeter: "", 
        useNestedObject: false 
    },
    { 
        name: "overTime", 
        title: "OT", 
        objectFieldsToDisplay: ["overTime"],
        objectFieldsDelimeter: "", 
        useNestedObject: false 
    },
    { 
        name: "doubleTime", 
        title: "DT", 
        objectFieldsToDisplay: ["doubleTime"],
        objectFieldsDelimeter: "", 
        useNestedObject: false 
    },
    {
        name: "notification",
        title: "",
        objectFieldsToDisplay: ["lastNotification"],
        objectFieldsDelimeter: "",
        useNestedObject: false,
        minWidth: 10,
        maxWidth: 100,
        renderCell: (params) => {

            let title = "No notification sent"
            let isNotified = false

            if(params.value){
                title = `Last notification sent on ${params.value}`
                isNotified = true
            }

            return <Tooltip title={title}>
                <IconButton disableRipple>
                    <NotificationsIcon color={isNotified ? 'primary' : 'disabled'} />
                </IconButton>
            </Tooltip>
        }
    }
];

const JobDayDetailAssignments = ({ data = { jobDay: { crewMemberAssignments: [], isForeman: false }}, loading, error }) => {

    const cleanedData = cleanJobDayAssignments(data.jobDay.crewMemberAssignments)

    return (<Container maxWidth={false} disableGutters sx={{ marginTop: 8, marginBottom: 8}}>

        <Typography variant='h4'>Assignments</Typography>
        <Box sx={{ height: 500, width: "100%", marginTop: 2}}>
            
            <BaseTable
                rawData={cleanedData}
                columnConfigs={crewDetailColumnConfigs}
                loading={loading}
            />
        </Box>
    </Container>
    );
}

export default JobDayDetailAssignments;